import React from "react";
import "./Navbar.css";
import logo from "../logo.png";
import { Link } from "react-router-dom";
import Popup from "reactjs-popup";
function Navbar() {
  return (
    <div className="Navbar">
      <Link className="route" to={"/"}>
        <img className="img" src={logo} />
      </Link>
      <Link className="route" to={"/lectures"}>
        <p className="tags">Lectures</p>
      </Link>
      <Link className="route" to={"/assignments"}>
        <p className="tags">Assignments</p>
      </Link>
      <Link className="route" to={"/quizzes"}>
        <p className="tags">Quizzes</p>
      </Link>
      <Link className="route" to={"/tickets"}>
        <p className="tags">Tickets</p>
      </Link>
      <Link className="route" to={"/discussions"}>
        <p className="tags">Discussions</p>
      </Link>
      <Link className="route" to={"/notifications"}>
        <p className="tags">Notifications</p>
      </Link>
      <Link className="route" to={"/messages"}>
        <p className="tags">Messages</p>
      </Link>
      <Link className="route" to={"/electives"}>
        <p className="tags">Electives</p>
      </Link>
      <Link className="route" to={"/courses"}>
        <p className="tags">Courses</p>
      </Link>
      <Link className="route" to={"/admin"}>
        <p className="tags">Admin</p>
      </Link>
      <div className="container">
        <div>
          <Popup
            className="pop"
            trigger={<p className="user"></p>}
            modal
            nested
          >
            <div className="profile">
              <div style={{ padding: "10px" }}>
                <p> Manage Account </p>
                <Link
                  style={{ textDecaration: "none", color: "black" }}
                  to={"/user/profile"}
                >
                  <p className="select">Profile</p>
                </Link>
                <p className="select">Log Out</p>
              </div>
            </div>
          </Popup>
        </div>
      </div>
    </div>
  );
}
export default Navbar;
